import Hero from "../components/site/Hero";
import ServicesOverview from "../components/site/ServicesOverview";
import Metrics from "../components/site/Metrics";
import Process from "../components/site/Process";
import FinalCTA from "../components/site/FinalCTA";
import { usePageSEO, breadcrumb } from "../hooks/usePageSEO";

export default function Home() {
  usePageSEO({
    title: "Daos Ads | Automatización IA, Funnels y Performance Marketing",
    description:
      "Consultor experto en automatización con IA, chatbots, Respond.io, Google Ads, Meta Ads y TikTok Ads. Implemento sistemas omnicanal que escalan ventas para empresas medianas y grandes en Latinoamérica. Gana más, pierde cero.",
    path: "/",
    jsonLd: [
      breadcrumb([{ name: "Inicio", path: "/" }]),
    ],
  });
  return (
    <>
      <Hero />
      <ServicesOverview />
      <Metrics />
      <Process />
      <FinalCTA />
    </>
  );
}
